import { I18nPluralPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { Table } from '../constants/table.constants';

@Pipe({
    name: 'days'
})
export class DaysPipe implements PipeTransform {
    private _singleDay = this._i18n({
        value: '# Day',
        meaning: 'Template for {1 Day} pluralization'
    });

    private _multipleDays = this._i18n({
        value: '# Days',
        meaning: 'Template for {X Days} pluralization'
    });

    constructor(private _i18n: I18n, private i18nPluralPipe: I18nPluralPipe) {}

    public transform(val: string | number, showZeroValue = false): string {
        if (typeof val === 'string') {
            val = parseFloat(val);
        }
        return this.i18nPluralPipe.transform(val, {
            '=0': showZeroValue ? this._multipleDays : Table.NullAmount,
            '=1': this._singleDay,
            other: this._multipleDays
        });
    }
}
